export const BASE_URL = process.env.REACT_APP_BASE_URL;
const config = {
  requestTimeout: 10000,
};

export default config;
